module.exports = __webpack_public_path__ + "static/media/S1_00043.111a86be.jpg";